import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import * as ScheduledDateActions from './schedule-date.actions';
import { ScheduledDate } from './schedule-date.model';

export const scheduledDatesFeatureKey = 'scheduledDates';

export interface State extends EntityState<ScheduledDate> {
    // additional entities state properties
}

export const adapter: EntityAdapter<ScheduledDate> =
    createEntityAdapter<ScheduledDate>({
        selectId: (model: ScheduledDate) => model.ScheduledDateID
    });

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

const scheduledDateReducer = createReducer(
    initialState,
    on(ScheduledDateActions.addScheduledDate, (state, action) =>
        adapter.addOne(action.scheduledDate, state)
    ),
    on(ScheduledDateActions.upsertScheduledDate, (state, action) =>
        adapter.upsertOne(action.scheduledDate, state)
    ),
    on(ScheduledDateActions.addScheduledDates, (state, action) =>
        adapter.addMany(action.scheduledDates, state)
    ),
    on(ScheduledDateActions.upsertScheduledDates, (state, action) =>
        adapter.upsertMany(action.scheduledDates, state)
    ),
    on(ScheduledDateActions.updateScheduledDate, (state, action) =>
        adapter.updateOne(action.scheduledDate, state)
    ),
    on(ScheduledDateActions.updateScheduledDates, (state, action) =>
        adapter.updateMany(action.scheduledDates, state)
    ),
    on(ScheduledDateActions.deleteScheduledDate, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(ScheduledDateActions.deleteScheduledDates, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(ScheduledDateActions.loadScheduledDates, (state, action) =>
        adapter.setAll(action.scheduledDates, state)
    ),
    on(ScheduledDateActions.clearScheduledDates, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return scheduledDateReducer(state, action);
}
